import { ReactNode } from "react";
import { useTranslation } from "react-i18next";

import { LoadingIndicator, Typography } from "@digital-services/ui";

import ErrorComponent from "@components/ErrorComponent";

import { useGetOrganizationById } from "@organization/services/use-get-organization-by-id";

interface Props {
  parentOrganizationId?: string;
}

export const ParentOrganizationName = ({ parentOrganizationId }: Props) => {
  const { t } = useTranslation(undefined, { keyPrefix: "parent-organization" });

  const { organization, error, isLoading } = useGetOrganizationById(
    parentOrganizationId!
  );

  let content: ReactNode | null = null;

  if (isLoading) {
    content = <LoadingIndicator />;
  } else if (error) {
    content = <ErrorComponent message={t("message-error")} />;
  } else if (organization?.name) {
    content = organization?.name;
  } else {
    content = "N/A";
  }

  return (
    <div data-testid="parent-organization-name">
      <Typography variant="smallTitle">{t("label-on-details")}</Typography>
      <div className="text-base">{content}</div>
    </div>
  );
};
